import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-causal',
  templateUrl: './causal.component.html',
  styleUrls: ['./causal.component.css']
})
export class CausalComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
